/**
 * Open a PDF URL in a new tab once the blob is ready.
 * Matches the main-branch flow: wait for the label, then window.open.
 */
export function openPdfInNewTab(pdfUrl) {
    if (!pdfUrl) return false;
    const tab = window.open(pdfUrl, "_blank");
    return Boolean(tab);
}
